<template>
  <div class="latest-txn">
    <el-table :data="list" @row-click="goDetailFn">
      <el-table-column prop="txId" label="交易ID" :min-width="adaptationVars.idColWidth" align="left" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row['txId'] || $constants.EMPTY }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="orgId" label="交易发送组织" :min-width="adaptationVars.orgColWidth" align="left" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row['orgId'] || $constants.EMPTY }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sender" label="交易发起用户" :min-width="adaptationVars.senderColWidth" align="left" class-name="sender"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row['sender'] || $constants.EMPTY }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="timestamp" label="交易发起时间" :min-width="adaptationVars.timeColWidth" align="left" class-name="create-time">
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row['timestamp']) || $constants.EMPTY }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'LatestTxn',
  mixins: [adaptation],
  adaptationVarsDefine: {
    idColWidth: 323,
    orgColWidth: 199,
    senderColWidth: 144,
    timeColWidth: 96
  },
  data() {
    return {
      adaptationVars: {
        idColWidth: 323,
        orgColWidth: 199,
        senderColWidth: 144,
        timeColWidth: 96
      },
      list: []
    }
  },
  watch: {
    '$store.state.home.chainCid': {
      deep: true,
      handler() {
        this.getNewTxListFn()
      }
    }
  },
  mounted() {
    if (this.$store.state.home.chainCid) {
      this.getNewTxListFn()
    }
  },

  methods: {
    ...mapActions(['getTxnLists']),
    // 获取最新交易
    getNewTxListFn() {
      let params = {
        offset: 0,
        limit: 5,
        chainId: this.$store.state.home.chainCid
      }
      this.getTxnLists(params).then(res => {
        this.list = res.items;
        this.$store.commit('updateLoading', false)
      })
    },
    formatTime(row) {
      return this.$utils.dateFormat('mm-dd HH:MM:SS', row)
    },
    // 跳转详情页
    goDetailFn(val) {
      this.$router.push({
        name: 'txnDetail',
        query: { txId: val.txId }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.latest-txn {
  height: 100%;
  padding: var(--home-trans-padding);
  font-size: var(--home-trans-fontsize);
  font-style: normal;
  font-weight: 350;
  line-height: normal;

  .el-table {
    background-color: transparent;
    width: 100%;

    /deep/ {

      .el-table__body-wrapper {
        overflow-x: hidden;
      }

      .el-table__header {
        tr {
          height: var(--home-trans-row-height);
          font-size: var(--home-trans-fontsize);
          font-weight: 400;
          background-color: transparent;

          .el-table__cell {
            padding: var(--home-trans-cell-padding);
            border-bottom-color: var(--home-trans-cell-bottom-color);
            border-bottom-width: var(--home-trans-cell-border-bottom-width);
            background-color: transparent;

            .cell {
              line-height: var(--home-trans-cell-height);
              height: var(--home-trans-cell-height);
              font-weight: 400;
              white-space: nowrap;
              color: var(--home-trans-header-text-color);
              padding: var(--home-trans-cell-content-padding);
            }
          }
        }
      }

      .el-table__body {
        tr {
          cursor: pointer;
          height: var(--home-trans-row-height);
          font-size: var(--home-trans-fontsize);
          font-weight: 350;
          background-color: transparent;

          .el-table__cell {
            padding: var(--home-trans-cell-padding);
            border-bottom-color: var(--home-trans-cell-bottom-color);
            border-bottom-width: var(--home-trans-cell-border-bottom-width);

            .cell {
              line-height: var(--home-trans-cell-height);
              height: var(--home-trans-cell-height);
              white-space: nowrap;
              color: var(--home-trans-body-text-color);
              padding: var(--home-trans-cell-content-padding);
            }

            &.sender .cell {
              color: var(--home-trans-body-sender-text-color);
            }

            &.create-time .cell {
              color: var(--home-trans-body-create-time-text-color)
            }
          }

          &:last-child {
            .el-table__cell {
              border-bottom-color: transparent;
            }
          }

          &:hover {
            .el-table__cell {
              background-color: var(--home-trans-row-hover-background-color);
            }
          }
        }
      }
    }

    &::before {
      background-color: transparent !important;
    }
  }
}
</style>
